import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

import {TAisSliceState} from '../ais-slice-types';
import {loadAisCommentsRequestRowsTable, loadAisCommentsRequestTable} from './ais-comments-request-thunks';

export const createAisCommentsRequestExtraReducer = (builder: ActionReducerMapBuilder<TAisSliceState>) => {
    builder.addCase(loadAisCommentsRequestTable.fulfilled, (state, {payload}) => {
        state.aisCommentsRequest.aisCommentsRequestTable = payload.dataTable;
        state.aisCommentsRequest.recordsTotal = payload.recordsTotal;
    });
    builder.addCase(loadAisCommentsRequestRowsTable.fulfilled, (state, {payload}) => {
        state.aisCommentsRequest.aisInspectorCommentInfo = payload;
    });
};
